if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', () => {
            this.byUserNav = Date.now();
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          });
        });
        // Be You: a swipe on the main photos also counts as the shopper choosing what to look at
        this.elements.viewer.slider?.addEventListener('touchstart', () => (this.byUserNav = Date.now()), { passive: true });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      // Be You: the gallery order never changes (no prepend / no re-sorting). Choosing a type only makes its
      // photo the visible one: mark it active, bring it into view in the slider and mark its thumbnail.
      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();
        window.clearTimeout(this.byScrollTimer);
        this.byScrollTimer = window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            this.scrollSliderTo(activeMedia.parentElement, activeMedia);
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${activeMedia.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      // Scrolls a horizontal slider so that `item` sits at its start edge. Works for RTL and LTR
      // (Dawn's `scrollTo({ left: item.offsetLeft })` only works in LTR; in RTL it always lands on the first slide).
      scrollSliderTo(scroller, item) {
        if (!scroller || !item || scroller.scrollWidth <= scroller.clientWidth + 1) return;
        const sr = scroller.getBoundingClientRect();
        const ir = item.getBoundingClientRect();
        if (!sr.width || !ir.width) return;
        const cs = window.getComputedStyle(scroller);
        const delta =
          cs.direction === 'rtl'
            ? ir.right - (sr.right - (parseFloat(cs.borderRightWidth) || 0) - (parseFloat(cs.paddingRight) || 0))
            : ir.left - (sr.left + (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.paddingLeft) || 0));
        if (Math.abs(delta) < 1) return;
        scroller.scrollTo({ left: scroller.scrollLeft + delta });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);

        const strip = this.elements.thumbnails.slider || thumbnail.parentElement;
        if (!strip) return;
        const sr = strip.getBoundingClientRect();
        const tr = thumbnail.getBoundingClientRect();
        if (this.hasAttribute('data-by-side-gallery') && strip.scrollHeight > strip.clientHeight + 1) {
          const delta = tr.top < sr.top ? tr.top - sr.top : tr.bottom > sr.bottom ? tr.bottom - sr.bottom : 0;
          if (delta) strip.scrollTo({ top: strip.scrollTop + delta, behavior: 'auto' });
          return;
        }
        if (!tr.width || (tr.left >= sr.left - 10 && tr.right <= sr.right + 10)) return;
        this.scrollSliderTo(strip, thumbnail);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

